<template>
  <div class="field-container">
    <input type="checkbox" v-bind:checked="value" @change="onChange" :id="id" class="form-input" />
    <label :for="id" class="form-label">{{ $t(`forms.${label}`) }}</label>
  </div>
</template>

<script>
export default {
  name: 'VvFormCheckboxInput',
  computed: {
    isValid() {
      if (this.valid === null) {
        return this.value !== ''
      } else {
        return this.valid
      }
    }
  },
  props: {
    id: {
      type: String
    },
    label: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    value: {
      type: Boolean,
      default: false
    },
    valid: {
      type: Boolean,
      default: null
    }
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  methods: {
    onChange() {
      this.$emit('input', !this.value)
    }
  }
}
</script>

<style scoped lang="scss">
.field-container {
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
  justify-content: flex-start;
}
</style>
